import ContentItem from './ContentItem';
import { ContentItemData } from './types';

interface ContentProps {
  content: ContentItemData[];
}

const Content = ({ content }: ContentProps) => {
  return (
    <>
      {content.map((contentItem, index) => {
        return (
          <ContentItem
            content={contentItem}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          />
        );
      })}
    </>
  );
};

export default Content;
